import { useContext } from 'react';
import { OfflineContext } from '@/stores/OfflineContext';

export function useOffline() {
  const context = useContext(OfflineContext);
  if (context === undefined) {
    throw new Error('useOffline must be used within an OfflineProvider');
  }

  // Placeholder for queueing mutation logic
  const queueOperation = async (operationType: string, path: string, _data: any) => {
    if (context.isOnline) {
      // Execute directly
      console.log('Executing online operation', operationType, path);
      // Implementation omitted
    } else {
      console.log('Queueing offline operation', operationType, path);
      // Dexie insert
    }
  };

  return {
    isOnline: context.isOnline,
    syncPending: context.syncPending,
    conflictCount: context.conflictCount,
    triggerSync: context.triggerSync,
    queueOperation
  };
}
